<template>
    <v-img height="350px">
        <l-map
      style="height: 80vh; width: 100wh"
      :zoom="zoom"
      :center="center"
    >
      <l-tile-layer :url="url"></l-tile-layer>
      <l-marker :lat-lng="markerlat"></l-marker>
    </l-map>
    </v-img>
</template>

<script>
import L from 'leaflet'
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});


import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
export default {
  components: {
    LMap,
    LTileLayer,
    LMarker
  },
  data () {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 16,
      center: [20.6525484, -105.2227437],
      bounds: null,
      markerlat: [20.652570, -105.220546]
    };
  },
  mounted() {
    setTimeout(function() { window.dispatchEvent(new Event('resize')) }, 250);
    },
  methods: {
    zoomUpdated (zoom) {
      this.zoom = zoom;
    },
    centerUpdated (center) {
      this.center = center;
    },
    boundsUpdated (bounds) {
      this.bounds = bounds;
    }
  }
}
</script>

<style>
@import 'http://cdn.leafletjs.com/leaflet-0.7.5/leaflet.css';
</style>